<administrasjon-navigasjon aktiv="brukere">
<div class="administrasjon-brukere-side">
   @for (bruker of brukere(); track bruker.id) {
      <administrasjon-bruker [bruker]="bruker" (brukereKoblet)="lastBrukere()"/>
    }
</div>
</administrasjon-navigasjon>
